import React, { useState } from "react";
import toast from "react-hot-toast";
import { downloadDocumentApi } from "../lib/api";

function isUrl(value) {
  return /^https?:\/\//i.test(String(value || "").trim());
}

function extractDocumentId(value) {
  const v = String(value || "").trim();
  if (!v) return "";
  if (/^document:/i.test(v)) return v.split(":", 2)[1].trim();
  if (/\.(pdf|doc|docx|xls|xlsx|csv|png|jpg|jpeg|zip)$/i.test(v)) return v;
  return "";
}

export default function EvidenceReferenceView({ value }) {
  const [opening, setOpening] = useState(false);
  const raw = String(value || "").trim();
  const documentId = extractDocumentId(raw);

  if (!raw) return "-";

  if (isUrl(raw)) {
    return (
      <a href={raw} target="_blank" rel="noopener noreferrer">
        Open evidence
      </a>
    );
  }

  if (!documentId) return raw;

  const handleOpen = async () => {
    try {
      setOpening(true);
      const blob = await downloadDocumentApi(documentId);
      const url = window.URL.createObjectURL(blob);
      window.open(url, "_blank", "noopener,noreferrer");
      setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
    } catch (err) {
      toast.error(err?.message || "Failed to open evidence");
    } finally {
      setOpening(false);
    }
  };

  return (
    <button type="button" className="btn-linkish" onClick={handleOpen} disabled={opening}>
      {opening ? "Opening..." : "Open evidence"}
    </button>
  );
}
